var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconEarnAigProfile = function SvgIconEarnAigProfile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 47,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    y: 3,
    fill: "#fff",
    rx: 22
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0D81F3",
    d: "M26.183 24.14c.09.28.135.57.136.859h4.688c0-.272-.08-.544-.239-.78L23.16 12.93a1.374 1.374 0 0 0-.919-.59c.045.009.09.016.135.028l3.807 11.773Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#78CCFF",
    d: "m17.818 24.14 3.807-11.773a1.377 1.377 0 0 0-.784.561L13.233 24.22a1.397 1.397 0 0 0-.239.78h4.688c0-.29.046-.58.136-.859Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#55B4FB",
    d: "M17.818 25.863a2.792 2.792 0 0 1-.136-.863h-4.688c0 .273.08.547.239.783l7.608 11.288c.226.336.563.527.92.588-.046-.008-.091-.015-.136-.027l-3.807-11.77Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#0850AC",
    d: "M26.318 25a2.8 2.8 0 0 1-.136.863l-3.807 11.769a1.374 1.374 0 0 0 .784-.56l7.609-11.289c.16-.236.239-.51.238-.783h-4.688Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#006E87",
    d: "m22.855 12.926 7.45 11.292c.16.235.239.507.24.779h.462c0-.272-.08-.544-.238-.78l-7.609-11.29a1.357 1.357 0 0 0-.781-.552l.047.145c.164.099.312.232.429.406Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#003670",
    d: "M30.544 24.996c0 .273-.079.547-.238.783l-7.451 11.288a1.353 1.353 0 0 1-.43.406l-.046.145c.303-.083.584-.26.781-.551l7.608-11.288c.16-.236.24-.51.24-.783h-.464Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#55B4FB",
    d: "M17.683 24.999h8.636c0-.29-.046-.58-.136-.859l-3.807-11.773a1.516 1.516 0 0 0-.75 0L17.818 24.14c-.09.28-.135.57-.135.859Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#83E2FC",
    d: "M21.848 12.328c-.132.014-.168.026-.223.038L17.819 24.14c-.09.28-.135.569-.135.859h.868c0-.29.045-.58.135-.859l3.162-11.81Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#0D81F3",
    d: "M26.183 25.863c.09-.28.136-.572.136-.863h-8.636c0 .291.044.582.135.863l3.808 11.769c.226.062.52.063.75 0l3.807-11.77Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#33A3FF",
    d: "M21.848 37.662c-.165-.017-.17-.029-.223-.038L17.819 25.85a2.795 2.795 0 0 1-.135-.859h.868c0 .29.045.58.135.859l3.162 11.81Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#00809E",
    d: "M22.38 12.375h-.001l3.804 11.763c.09.28.136.57.136.859h.592c0-.29-.045-.58-.135-.859l-4.397-11.763Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#CFF8FF",
    d: "M21.193 12.566a1.368 1.368 0 0 0-.352.36l-7.608 11.29a1.397 1.397 0 0 0-.239.78h.805c0-.272.08-.544.238-.78l7.156-11.65Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#003670",
    d: "M22.38 37.622h-.001l3.804-11.764c.09-.279.136-.568.136-.858h.592c0 .29-.045.58-.135.858l-4.397 11.764Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#85D1FF",
    d: "M21.193 37.43a1.37 1.37 0 0 1-.352-.36l-7.608-11.29a1.397 1.397 0 0 1-.239-.78h.805c0 .272.08.544.238.78l7.156 11.65Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m27.23 18.967-4.07-6.039c-.568-.822-1.782-.799-2.319 0l-6.946 10.307c6.966.427 11.002-1.65 13.334-4.268Z",
    opacity: 0.15
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-earn-aig-profile_svg__a)",
    d: "M20.869 21.642a2.436 2.436 0 1 0 0-4.872 2.436 2.436 0 0 0 0 4.872Z",
    opacity: 0.5
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-earn-aig-profile_svg__b)",
    d: "m21.238 19.4.704.88-.88-.704-.194 1.747-.193-1.747-.88.704.704-.88-1.747-.194 1.747-.194-.705-.88.88.704.194-1.746.194 1.747.88-.705-.704.88 1.747.194-1.747.194Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-earn-aig-profile_svg__c)",
    d: "M17.634 30.814a36.475 36.475 0 0 0 1.932 2.947 37.409 37.409 0 0 0-3.583-6.07 36.532 36.532 0 0 0 1.651 3.123Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-earn-aig-profile_svg__d)",
    d: "M23.773 32.714a3.246 3.246 0 1 0 0-6.491 3.246 3.246 0 0 0 0 6.491Z",
    opacity: 0.3
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBBF24",
    d: "M33 16s0-8 6-8c-6 0-6-8-6-8s0 8-6 8c6 0 6 8 6 8ZM39 17s0-3 2-3c-2 0-2-3-2-3s0 3-2 3c2 0 2 3 2 3Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "icon-earn-aig-profile_svg__a",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(20.868 19.206) scale(2.436)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.306,
    stopColor: "#fff",
    stopOpacity: 0.999
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "icon-earn-aig-profile_svg__b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(20.868 19.206) scale(2.11638)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.306,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "icon-earn-aig-profile_svg__d",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(23.773 29.468) scale(3.24642)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.306,
    stopColor: "#fff",
    stopOpacity: 0.999
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-earn-aig-profile_svg__c",
    x1: 17.052,
    x2: 15.35,
    y1: 28.363,
    y2: 30.937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.442,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.641,
    stopColor: "#fff",
    stopOpacity: 0.999
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })))));
};
export default SvgIconEarnAigProfile;